module.exports = __webpack_public_path__ + "static/media/site_icon.fe97c406.png";